import React from 'react';
import {useSelector} from 'react-redux';
import {Stack, Typography} from '@mui/material';

import {getAccountSfid, getEmail} from '../app/store/reducers/session';

// Temporary placeholder for the "Today" tab content, rendered inside MainLayout's <main>.
// Replace this once the dashboard tables/tab content get their new-UI treatment.
const PostLoginPlaceholder = () => {
    const accountSfid = useSelector(getAccountSfid);
    const email = useSelector(getEmail);

    return (
        <Stack spacing={1}>
            <Typography variant="h4">You're logged in 🎉</Typography>
            <Typography variant="body2" color="text.secondary">
                account_sfid: {accountSfid || '(none yet)'} {email ? `· ${email}` : ''}
            </Typography>
            <Typography variant="caption" color="text.secondary">
                Dashboard tables and tab content haven't been ported to the new UI yet.
            </Typography>
        </Stack>
    );
};

export default PostLoginPlaceholder;
